mutation SetDefaultWidget($id: ID) {
  setDefaultWidget(id: $id)
}
